import React from 'react';
import MiniCart from '@/features/cart/MiniCart';
import Portal from "@/root/portals/Portal";

export default () => {
  return <Portal selector='#module-mini-cart'>
      {(dataset) => React.createElement(MiniCart, dataset)}
  </Portal>
};